import {call, put, takeEvery, takeLatest} from "redux-saga/effects";
import {PayloadAction} from "@reduxjs/toolkit";
import {setTokenCookie} from "../../../context";
import {apiGetGameCategories, apiGetGamesList,apiGetCardsList, apiGetOneGame, apiGetMaterials, apiGetOneCard, apiGetTalesList, apiGetInfographics, apiGetMaterialsTree, apiGetKindergartensList, apiGetChildrens, apiGetMainVideoList, apiGetContentByLesson, apiGetExportPDF, apiGetSensoryVideoList, apiGetExportResultsPDF, apiGetInfographicsByCode, apiGetArticleById, apiDeleteChild, apiGetPsychoCardsList, apiUpdateProfile, apiAddChild, apiUpdateChild, apiGetCardsThemeList, apiEvaluate, apiGetTestResults, apiGetRegions, apiGetListRequest, apiCreateApplication, apiSetLike, apiGetContentByCategory, apiGetArticleList, apiGetAutorsList, apiGetMarathonWeeks, apiGetMarathonDays, apiGetMarathonTasks, apiGetMarathonTask, apiSaveDiary, apiGetDiary, apiGetDiaryTable, apiTaskComplete} from "./api";
import {
  fetchGameCategoriesAction,
  fetchGameCategoriesActionDone,
  fetchGameCategoriesActionFail, fetchGamesListAction,
  fetchCardsListAction, fetchCardsListActionDone, fetchCardsListActionFail,
  fetchGamesListActionDone, fetchGamesListActionFail, fetchOneGameAction, fetchOneGameActionDone, fetchOneGameActionFail,
  fetchMaterialsAction,fetchMaterialsActionDone,fetchMaterialsActionFail,
  fetchOneCardActionDone,
  fetchOneCardActionFail,
  fetchOneCardAction,
  fetchTalesListActionDone,
  fetchTalesListActionFail,
  fetchTalesListAction,
  fetchInfographicsActionDone,
  fetchInfographicsActionFail,
  fetchInfographicsAction,
  fetchMaterialsTreeDone,
  fetchMaterialsTreeFail,
  fetchMaterialsTreeAction,
  fetchMaterialsDetailAction,
  fetchMaterialsDetailDone,
  fetchMaterialsDetailFail,
  fetchKindergartensListDone,
  fetchKindergartensListFail,
  fetchKindergartensListAction,
  fetchChildrensDone,
  fetchChildrensFail,
  fetchChildrensAction,
  fetchMainVideoListDone,
  fetchMainVideoListFail,
  fetchMainVideoListAction,
  fetchContentByLessonDone,
  fetchContentByLessonFail,
  fetchContentByLessonAction,
  fetchExportPDFDone,
  fetchExportPDFFail,
  fetchExportPDFAction,
  fetchSensoryVideoListDone,
  fetchSensoryVideoListFail,
  fetchSensoryVideoListAction,
  fetchExportResultsPDFDone,
  fetchExportResultsPDFFail,
  fetchExportResultsPDFAction,
  fetchInfographicsByCodeDone,
  fetchInfographicsByCodeFail,
  fetchInfographicsByCodeAction,
  fetchArticleByIdDone,
  fetchArticleByIdFail,
  fetchArticleByIdAction,
  fetchDeleteChildDone,
  fetchDeleteChildFail,
  fetchDeleteChildAction,
  fetchPsychoCardsListDone,
  fetchPsychoCardsListFail,
  fetchPsychoCardsListAction,
  fetchUpdateProfileDone,
  fetchUpdateProfileFail,
  fetchUpdateProfileAction,
  fetchAddChildFail,
  fetchAddChildDone,
  fetchUpdateChildFail,
  fetchUpdateChildDone,
  fetchAddChildAction,
  fetchUpdateChildAction,
  fetchCardsThemeListDone,
  fetchCardsThemeListFail,
  fetchCardsThemeListAction,
  fetchEvaluateDone,
  fetchEvaluateFail,
  fetchEvaluateAction,
  fetchTestResultsDone,
  fetchTestResultsFail,
  fetchTestResultsAction,
  fetchRegionsListDone,
  fetchRegionsListFail,
  fetchDistrictsListDone,
  fetchDistrictsListFail,
  fetchCitiesListDone,
  fetchCitiesListFail,
  fetchRegionsListAction,
  fetchDistrictsListAction,
  fetchCitiesListAction,
  fetchListRequestDone,
  fetchListRequestFail,
  fetchListRequestAction,
  fetchCreateApplicationDone,
  fetchCreateApplicationFail,
  fetchCreateApplicationAction,
  fetchSetLikeDone,
  fetchSetLikeFail,
  fetchSetLikeAction,
  fetchContentByCategoryDone,
  fetchContentByCategoryFail,
  fetchContentByCategoryAction,
  fetchMarathonWeeksActionDone,
  fetchMarathonWeeksActionFail,
  fetchMarathonDaysActionDone,
  fetchMarathonDaysActionFail,
  fetchMarathonTasksActionDone,
  fetchMarathonTasksActionFail,
  fetchMarathonTaskActionDone,
  fetchMarathonTaskActionFail,
  fetchMarathonTaskAction,
  fetchMarathonTasksAction,
  fetchMarathonDaysAction,
  fetchMarathonWeeksAction,
  saveDiaryActionDone,
  saveDiaryActionFail,
  saveDiaryAction,
  fetchDiaryActionDone,
  fetchDiaryActionFail,
  fetchDiaryAction,
  fetchDiaryTableActionDone,
  fetchDiaryTableActionFail,
  fetchDiaryTableAction,
  taskCompleteActionDone,
  taskCompleteActionFail,
  taskCompleteAction,
} from "./actions";
import { fetchGetProfile, fetchModules } from "../profile";


function* gameCategoriesFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetGameCategories, payload)
    if (data) {
      yield put(fetchGameCategoriesActionDone(data))

    }

  } catch (e) {
    // todo: Костыль
    // const errData = [
    //   {
    //     "id": 1,
    //     "name": "Логика"
    //   },
    //   {
    //     "id": 2,
    //     "name": "Математика"
    //   },
    //   {
    //     "id": 3,
    //     "name": "Внимание"
    //   },
    //   {
    //     "id": 4,
    //     "name": "Буквы и цифры"
    //   },
    //   {
    //     "id": 5,
    //     "name": "Симметрия"
    //   },
    //   {
    //     "id": 6,
    //     "name": "Фигуры"
    //   }
    // ]
    yield put(fetchGameCategoriesActionFail())

    // yield put(fetchGameCategoriesActionFail(errData))
  }
}

function* gamesListFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetGamesList, payload)
    if (data) {
      yield put(fetchGamesListActionDone(data))

    }

  } catch (e) {
    // todo: Костыль
    const errData = [
      {
        "id": 9,
        "category_id": 2,
        "title": "Счёт по порядку. Продолжи ряд",
        "engine": "dragGame",
        "minAge": 2,
        "maxAge": 4,
        "iconImage": "https://ff.bilimal.kz/skuggcke/oysywuou/wascsoug/30adae1a1d3bd26d65374d6546aa331ab77ee1db.png"
      }
    ]
    yield put(fetchGamesListActionFail(errData))
  }
}

function* cardsListFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetCardsList, payload)
    if (data) {
      yield put(fetchCardsListActionDone(data))

    }

  } catch (e) {
    // todo: Костыль
    const errData = [
      {
        "id": 9,
        "category_id": 2,
        "title": "Счёт по порядку. Продолжи ряд",
        "engine": "dragGame",
        "minAge": 2,
        "maxAge": 4,
        "iconImage": "https://ff.bilimal.kz/skuggcke/oysywuou/wascsoug/30adae1a1d3bd26d65374d6546aa331ab77ee1db.png"
      }
    ]
    yield put(fetchCardsListActionFail(errData))
  }
}

function* talesListFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetTalesList, payload)
    if (data) {
      yield put(fetchTalesListActionDone(data))

    }

  } catch (e) {
   const errData = {
      }
    yield put(fetchTalesListActionFail(errData))
  }
}


function* oneCardFlow({payload}:PayloadAction<any>): any {
    try {
      const data = yield call(apiGetOneCard, payload)
      if (data) {
        yield put(fetchOneCardActionDone(data))
      }
  
    } catch (e) {

      const errData = {
      }
      yield put(fetchOneCardActionFail(errData))
    }
  }

function* oneGameFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetOneGame, payload)
    if (data) {
      yield put(fetchOneGameActionDone(data))

    }

  } catch (e) {
    // todo: Костыль
    const errData = {
      "id": 9,
      "category_id": 2,
      "title": "Счёт по порядку. Продолжи ряд",
      "task_text": "Счёт по порядку. Продолжи ряд",
      "audio": "https://ff.bilimal.kz/skuggcke/oysywuou/wascsoug/c98c4d9bffd217360e70c3806ad40c95e7230020.ogg",
      "engine": "dragGame",
      "minAge": 2,
      "maxAge": 4,
      "selectedBlock": "2",
      "iconImage": "https://ff.bilimal.kz/skuggcke/oysywuou/wascsoug/30adae1a1d3bd26d65374d6546aa331ab77ee1db.png",
      "taskImages": [
        "https://ff.bilimal.kz/skuggcke/oysywuou/wascsoug/7921eb8b32c14840d9329920527ada335f469e83.png",
        "https://ff.bilimal.kz/skuggcke/oysywuou/wascsoug/71ccddfaef3192091e2d40f3d9ff9a24223d12ee.png",
        "https://ff.bilimal.kz/skuggcke/oysywuou/wascsoug/ac2f8cf766c6b678e668346c9c755d8f36ca8437.png"
      ],
      "backgrounds": [
        "https://ff.bilimal.kz/skuggcke/oysywuou/wascsoug/ce3a93ed84c031b11f087aa9056e5759349b56ba.jpg",
        "https://ff.bilimal.kz/skuggcke/oysywuou/wascsoug/0640df5f45fe2f156588af6c1899ddaca78fc363.jpg",
        "https://ff.bilimal.kz/skuggcke/oysywuou/wascsoug/487a9083eccde199dbb050f219469a912a6d9890.jpg"
      ],
      "choiceImages": [
        "https://ff.bilimal.kz/skuggcke/oysywuou/wascsoug/1646e90575b03701588ca9e7a24eea7bbb8c3a6b.png",
        "https://ff.bilimal.kz/skuggcke/oysywuou/wascsoug/ac2f8cf766c6b678e668346c9c755d8f36ca8437.png",
        "https://ff.bilimal.kz/skuggcke/oysywuou/wascsoug/6730464ad9d1b730b6a6c13af7e97e3960834d77.png"
      ],
      "correctImage": 1
    }

    yield put(fetchOneGameActionFail(errData))
  }
}

function* materialsFlow({payload}:PayloadAction<any>): any {
    try {
      const data = yield call(apiGetMaterials, payload)
      if (data) {
        yield put(fetchMaterialsActionDone(data))
      }
  
    } catch (e) {
      yield put(fetchMaterialsActionFail())
    }
  }

function* infographicsFlow({payload}:PayloadAction<any>): any {
    try {
      const data = yield call(apiGetInfographics, payload)
      if (data) {
        yield put(fetchInfographicsActionDone(data))
      }
  
    } catch (e) {
      yield put(fetchInfographicsActionFail())
    }
  }

function* materialsTreeFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiGetMaterialsTree, {
      parent_id: payload,
    });

    const materialsList = response?.tree || [];

    const type5Item = materialsList.find((item: any) => item.type === "5");

    let materials5List: any[] = [];

    if (type5Item?.id) {
      const secondResponse = yield call(apiGetMaterialsTree, {
        parent_id: type5Item.id,
      });

      materials5List = secondResponse?.tree || [];
    }

    yield put(
      fetchMaterialsTreeDone({
        tree: materialsList,
        materials5List,
      })
    );
  } catch (e) {
    const errData = {
      }
    yield put(fetchMaterialsTreeFail(errData));
  }
}

export function* materialsDetailFlow({ payload }: any): any {
  try {
    const data = yield call(apiGetMaterialsTree, {
      parent_id: payload.id,
    });

    const tree = data?.tree || [];

    const types = tree.length > 0
      ? tree.map((item: any) => ({
          label: item.name,
          value: item.id,
          id: item.id,
          scenary: item.scenaries?.[0],
        }))
      : [];

    const hasData = tree.length > 0;
    let currentId = null;
    let searchValueParam = null;

    if (hasData) {
      if (!payload.segmentedParams && payload.typeId == null) {
        searchValueParam = types[0].scenary;
        currentId = types[0].id;
      } else {
        // typeId is the only unique identifier: several tabs can share the same
        // scenary (Задания и Зрительная гимнастика оба приходят как "lessons").
        const byId =
          payload.typeId != null
            ? types.find((t: any) => String(t.id) === String(payload.typeId))
            : null;

        // MaterialsDetail кладёт в ?type= scenary, MaterialsPage — label,
        // поэтому ищем по обоим полям.
        const byParam = payload.segmentedParams
          ? types.find(
              (t: any) =>
                String(t.scenary) === String(payload.segmentedParams) ||
                String(t.label) === String(payload.segmentedParams)
            )
          : null;

        const selected = byId || byParam;

        if (selected) {
          currentId = selected.id;
        } else {
          currentId = types[0].id;
          searchValueParam = types[0].scenary;
        }
      }
    }

    let materials: any[] = [];
    if (currentId) {
      const materialsResponse = yield call(apiGetMaterialsTree, {
        parent_id: currentId,
      });
      materials = materialsResponse?.tree || [];
    }

    yield put(fetchMaterialsDetailDone({
      name: data.name,
      tree,  
      types,
      materials, 
      hasData,
      currentId,
      searchValueParam,
    }));

  } catch (error) {
    yield put(fetchMaterialsDetailFail({}));
  }
}

function* kindergartensListFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiGetKindergartensList, payload);
    yield put(fetchKindergartensListDone(response));
  } catch (e) {
    yield put(fetchKindergartensListFail({}));
  }
}

function* childrensFlow(): any {
  try {
    const response = yield call(apiGetChildrens);
    yield put(fetchChildrensDone(response));
  } catch (e) {
    yield put(fetchChildrensFail({}));
  }
}

function* mainVideoListFlow(): any {
  try {
    const response = yield call(apiGetMainVideoList);
    yield put(fetchMainVideoListDone(response));
  } catch (e) {
    yield put(fetchMainVideoListFail({}));
  }
}

function* contentByLessonFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiGetContentByLesson, payload);
    yield put(fetchContentByLessonDone({
      lessonId: payload.id,
      content: response.content,
    }));
  } catch (e) {
    yield put(fetchContentByLessonFail({}));
  }
}

function* exportPDFFlow({ payload }: PayloadAction<{ id: number; name: string }>): any {
  try {
    const response = yield call(apiGetExportPDF, payload.id);

    const cleanName = payload.name
      .replace(/<br\s*\/?>/gi, '')
      .replace(/\s+/g, "_")
      .replace(/[^\wа-яА-ЯёЁ_]/g, "");

    const fileName = `Задание_${cleanName}.pdf`;

    const url = window.URL.createObjectURL(response);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    yield put(fetchExportPDFDone(response));
  } catch (e) {
    yield put(fetchExportPDFFail({}));
  }
}

function* sensoryVideoListFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiGetSensoryVideoList, payload);
    yield put(fetchSensoryVideoListDone(response));
  } catch (e) {
    yield put(fetchSensoryVideoListFail({}));
  }
}

function* exportResultsPDFFlow({ payload }: PayloadAction<{ id: any; typeName: string }>): any {
  try {
    const response = yield call(apiGetExportResultsPDF, payload.id);

    const fileName = `${payload.typeName} SabiDamu ${payload.id}.pdf`;

    const url = window.URL.createObjectURL(response);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    yield put(fetchExportResultsPDFDone({}));
  } catch (e) {
    yield put(fetchExportResultsPDFFail({}));
  }
}

function* infographicsByCodeFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiGetInfographicsByCode, payload);
    yield put(fetchInfographicsByCodeDone(response));
  } catch (e) {
    yield put(fetchInfographicsByCodeFail({}));
  }
}

function* articleByIdFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiGetArticleById, payload);
    yield put(fetchArticleByIdDone(response));
  } catch (e) {
    yield put(fetchArticleByIdFail({}));
  }
}

function* deleteChildFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiDeleteChild, payload);
    yield put(fetchDeleteChildDone(response));
    yield put(fetchChildrensAction({}));
  } catch (e) {
    yield put(fetchDeleteChildFail({}));
  }
}

function* psychoCardsListFlow(): any {
  try {
    const response = yield call(apiGetPsychoCardsList);
    yield put(fetchPsychoCardsListDone(response));
  } catch (e) {
    yield put(fetchPsychoCardsListFail({}));
  }
}

function* updateProfileFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiUpdateProfile, payload.profileData);
    yield put(fetchUpdateProfileDone(response));
    yield put(fetchModules({}));
    if (payload.withRefetch) {
      yield put(fetchGetProfile({}));
    }
  } catch (e) {
    yield put(fetchUpdateProfileFail(e));
  }
}

function* addChildFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiAddChild, payload.childData);

    if (response?.errors) {
      yield put(fetchAddChildFail(response.errors));
      return;
    }

    yield put(fetchAddChildDone(response));
    yield put(fetchModules({}));
    yield put(fetchChildrensAction({}));
  } catch (e: any) {
    yield put(
      fetchAddChildFail(
        e?.response?.data?.errors || e?.response?.data || e.message || "Unknown error"
      )
    );
  }
}

function* updateChildFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiUpdateChild, { id: payload.id, payload: payload.childData });

    if (response?.errors) {
      yield put(fetchUpdateChildFail(response.errors));
      return;
    }

    yield put(fetchUpdateChildDone(response));
    yield put(fetchModules({}));
    yield put(fetchChildrensAction({}));
  } catch (e) {
    yield put(fetchUpdateChildFail({}));
  }
}

function* cardsThemeListFlow(): any {
  try {
    const response = yield call(apiGetCardsThemeList);
    yield put(fetchCardsThemeListDone(response));
  } catch (e) {
    yield put(fetchCardsThemeListFail({}));
  }
}

function* evaluateFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiEvaluate, payload);
    yield put(fetchEvaluateDone(response));
  } catch (e) {
    yield put(fetchEvaluateFail({}));
  }
}

function* testResultsFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiGetTestResults, payload);
    yield put(fetchTestResultsDone(response));
  } catch (e) {
    yield put(fetchTestResultsFail({}));
  }
}

function* regionsListFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiGetRegions, payload);
    yield put(fetchRegionsListDone(response));
  } catch (e) {
    yield put(fetchRegionsListFail({}));
  }
}

function* districtsListFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiGetRegions, payload);
    yield put(fetchDistrictsListDone(response));
  } catch (e) {
    yield put(fetchDistrictsListFail({}));
  }
}

function* citiesListFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiGetRegions, payload);
    yield put(fetchCitiesListDone(response));
  } catch (e) {
    yield put(fetchCitiesListFail({}));
  }
}

function* listRequestFlow(): any {
  try {
    const response = yield call(apiGetListRequest);
    yield put(fetchListRequestDone(response));
  } catch (e) {
    yield put(fetchListRequestFail({}));
  }
}

function* createApplicationFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiCreateApplication, payload);
    yield put(fetchCreateApplicationDone(response));
  } catch (e: any) {
    yield put(fetchCreateApplicationFail(e?.response?.data || {}));
  }
}

function* setLikeFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiSetLike, payload);
    yield put(fetchSetLikeDone(response));
  } catch (e) {
    yield put(fetchSetLikeFail({}));
  }
}

function* contentByCategoryFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiGetContentByCategory, payload.categoryId);
    const themes = response.themes || [];
    if (payload.loadFirstTheme) {
      const firstType1Theme = themes.find((t: any) => t.type === 1);
      if (firstType1Theme) {
        const lessonResponse = yield call(apiGetContentByCategory, payload.categoryId, firstType1Theme.id);
        yield put(fetchContentByCategoryDone({
          ...response,
          firstThemeLessons: lessonResponse.content,
          firstTheme: firstType1Theme,
        }));
        return;
      }
    }

    if (payload.topicId) {
      const topicTheme = themes.find((t: any) => t.id == payload.topicId);
      if (topicTheme) {
        const lessonResponse = yield call(apiGetContentByCategory, payload.categoryId, topicTheme.id);
        yield put(fetchContentByCategoryDone({
          ...response,
          topicLessons: lessonResponse.content,
          selectedSubThemeName: topicTheme.name,
          selectedSubThemeId: topicTheme.id,
          activeKeyTheme: topicTheme.parent_id,
          selectedParentTheme: topicTheme,
        }));
        return;
      }
    }

    if (!payload.topicId) {
      const lessonResponse = yield call(apiGetContentByCategory, payload.categoryId);
      yield put(fetchContentByCategoryDone({
        ...response,
        allLessons: lessonResponse.content,
      }));
      return;
    }

    yield put(fetchContentByCategoryDone(response));
  } catch (e) {
    yield put(fetchContentByCategoryFail({}));
  }
}

function* marathonWeeksFlow(): any {
  try {
    const data = yield call(apiGetMarathonWeeks)

    if (data) {
      yield put(fetchMarathonWeeksActionDone(data))
    }
  } catch (e) {
    const errData = {}

    yield put(fetchMarathonWeeksActionFail(errData))
  }
}

function* marathonDaysFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetMarathonDays, payload)

    if (data) {
      yield put(fetchMarathonDaysActionDone(data))
    }
  } catch (e) {
    const errData = {}

    yield put(fetchMarathonDaysActionFail(errData))
  }
}

function* marathonTasksFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetMarathonTasks, payload)

    if (data) {
      yield put(fetchMarathonTasksActionDone(data))
    }
  } catch (e) {
    const errData = {}

    yield put(fetchMarathonTasksActionFail(errData))
  }
}

function* marathonTaskFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetMarathonTask, payload)

    if (data) {
      yield put(fetchMarathonTaskActionDone(data))
    }
  } catch (e) {
    const errData = {}

    yield put(fetchMarathonTaskActionFail(errData))
  }
}

function* saveDiaryFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiSaveDiary, payload)

    if (data) {
      yield put(saveDiaryActionDone(data))
    }
  } catch (e) {
    const errData = {}

    yield put(saveDiaryActionFail(errData))
  }
}

function* fetchDiaryFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetDiary, payload)
    if (data) {
      yield put(fetchDiaryActionDone(data))
    }
  } catch (e) {
    yield put(fetchDiaryActionFail({}))
  }
}

function* fetchDiaryTableFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetDiaryTable, payload)
    if (data) {
      yield put(fetchDiaryTableActionDone(data))
    }
  } catch (e) {
    yield put(fetchDiaryTableActionFail({}))
  }
}

function* taskCompleteFlow({ payload }: PayloadAction<any>): any {
  try {
    const data = yield call(apiTaskComplete, payload)
    if (data) {
      yield put(taskCompleteActionDone(data))
    }
  } catch (e) {
    yield put(taskCompleteActionFail({}))
  }
}

export default function* materialsSaga() {
  yield takeLatest(fetchGameCategoriesAction, gameCategoriesFlow);
  yield takeLatest(fetchGamesListAction, gamesListFlow);
  yield takeLatest(fetchCardsListAction, cardsListFlow);
  yield takeLatest(fetchTalesListAction, talesListFlow);
  yield takeLatest(fetchOneGameAction, oneGameFlow);
  yield takeLatest(fetchOneCardAction, oneCardFlow);
  yield takeLatest(fetchMaterialsAction, materialsFlow);
  yield takeLatest(fetchInfographicsAction, infographicsFlow);
  yield takeLatest(fetchMaterialsTreeAction, materialsTreeFlow);
  yield takeLatest(fetchMaterialsDetailAction, materialsDetailFlow);
  yield takeLatest(fetchKindergartensListAction, kindergartensListFlow);
  yield takeLatest(fetchChildrensAction, childrensFlow);
  yield takeLatest(fetchMainVideoListAction, mainVideoListFlow);
  yield takeLatest(fetchContentByLessonAction, contentByLessonFlow);
  yield takeLatest(fetchExportPDFAction, exportPDFFlow);
  yield takeLatest(fetchSensoryVideoListAction, sensoryVideoListFlow);
  yield takeLatest(fetchExportResultsPDFAction, exportResultsPDFFlow);
  yield takeLatest(fetchInfographicsByCodeAction, infographicsByCodeFlow);
  yield takeLatest(fetchArticleByIdAction, articleByIdFlow);
  yield takeLatest(fetchDeleteChildAction, deleteChildFlow);
  yield takeLatest(fetchPsychoCardsListAction, psychoCardsListFlow);
  yield takeLatest(fetchUpdateProfileAction, updateProfileFlow);
  yield takeLatest(fetchAddChildAction, addChildFlow);
  yield takeLatest(fetchUpdateChildAction, updateChildFlow);
  yield takeLatest(fetchCardsThemeListAction, cardsThemeListFlow);
  yield takeLatest(fetchEvaluateAction, evaluateFlow);
  yield takeLatest(fetchTestResultsAction, testResultsFlow);
  yield takeLatest(fetchRegionsListAction, regionsListFlow);
  yield takeLatest(fetchDistrictsListAction, districtsListFlow);
  yield takeLatest(fetchCitiesListAction, citiesListFlow);
  yield takeLatest(fetchListRequestAction, listRequestFlow);
  yield takeLatest(fetchCreateApplicationAction, createApplicationFlow);
  yield takeLatest(fetchSetLikeAction, setLikeFlow);
  yield takeLatest(fetchContentByCategoryAction, contentByCategoryFlow);
  yield takeLatest(fetchMarathonWeeksAction, marathonWeeksFlow);
  yield takeLatest(fetchMarathonDaysAction, marathonDaysFlow);
  yield takeEvery(fetchMarathonTasksAction, marathonTasksFlow);
  yield takeLatest(fetchMarathonTaskAction, marathonTaskFlow);
  yield takeLatest(saveDiaryAction, saveDiaryFlow);
  yield takeLatest(fetchDiaryAction, fetchDiaryFlow);
  yield takeLatest(fetchDiaryTableAction, fetchDiaryTableFlow);
  yield takeLatest(taskCompleteAction, taskCompleteFlow);
}